// extracted by mini-css-extract-plugin
export default {"projectWorkplace":"ProjectWorkplace_projectWorkplace__KpcT8"};